import {
  QueryParamsForReviewUrlPropsBase64Type,
  QueryParamsForReviewUrlPropsTypes,
} from '@stencil/hotels-types/src/details-types';
import {Assign} from 'utility-types';
import {
  ICityMetaInfo,
  IHotelData,
} from '../../../../verticals/hotels-dweb/src/shared/pages/SRP/redux/types';

export interface ICommonStoreState {
  destination: ICityVoyagerObj;
  checkin: ICheckinCheckoutDate;
  checkout: ICheckinCheckoutDate;
  roomString: string;
  country: string;
  partner: string;

  // ! this can be spliced off into separate reducer
  segmentSliderApi: {
    isLoading: boolean;
    data: Object;
    error?: string | boolean;
  };
  metaPartner: string;
  selectedHotel: {
    propertyId?: string;
    propertyName?: string;
    propertyVendor?: string;
    hmd?: string;
    queryParamsForReviewUrlPropsBase64?: Partial<QueryParamsForReviewUrlPropsBase64Type>;
    descBlockInput?: Partial<Assign<QueryParamsForReviewUrlPropsTypes, {paxString: string}>>;
    ecomParams?: {
      showPrice?: number;
      currency?: string;
    };
    selected?: boolean;
    reviewType?: string;
  };
  autosuggestOpenedBy: string;
  calenderProgressiveSearchFormOpenedBy: string;
  isPageHeaderSearchWidgetOpen: boolean;
}

export interface ICityVoyagerObj {
  n: string;
  _id: string;
  t?: string;
  xtr?: {
    cc: string;
    flt?: {
      loc: {_id: string; n: string};
    };
  };
  ct?: {
    _id: string;
    n: string;
  };
  crd?: Array<number>;
}

export interface AutosuggestOpenedByPageType {
  page:
    | 'srp'
    | 'home'
    | 'details'
    | 'roomSelectionPage'
    | 'details-location'
    | 'calendar'
    | 'progressiveSearchForm';
}

export interface ICheckinCheckoutDate {
  date: Date;
  isMidnight?: boolean;
  isMachineGenerated?: boolean;
}

export interface ISegmentSliderData {
  data_list: Array<ISegmentSliderDataItem>;
  city_meta_info: ICityMetaInfo;
}

export interface ISegmentSliderDataItem {
  data: Array<IHotelData>;
  banner_data: {t: string; mbg?: Array<string>; img?: string};
}

export const UPDATE_QUERY = 'UPDATE_QUERY';
export const TOGGLE_LOADING_SEGMENT_SLIDER = 'TOGGLE_LOADING_SEGMENT_SLIDER';
export const ERROR_LOADING_SEGMENT_SLIDER = 'ERROR_LOADING_SEGMENT_SLIDER';
export const UPDATE_SEGMENT_SLIDER_DATA = 'UPDATE_SEGMENT_SLIDER_DATA';
export const RESET_SEGMENT_SLIDER = 'RESET_SEGMENT_SLIDER';
export const UPDATE_SELECTED_PROPERTY = 'UPDATE_SELECTED_PROPERTY';
export const RESET_SELECTED_PROPERTY = 'RESET_SELECTED_PROPERTY';
export const UPDATE_AUTOSUGGEST_OPENED_BY = 'UPDATE_AUTOSUGGEST_OPENED_BY';
export const UPDATE_CALENDAR_PROGRESSIVE_SEARCH_FORM_OPENED_BY =
  'UPDATE_CALENDAR_PROGRESSIVE_SEARCH_FORM_OPENED_BY';
export const UPDATE_PAGEHEADER_SEARCH_WIDGET_OPEN_STATE =
  'UPDATE_PAGEHEADER_SEARCH_WIDGET_OPEN_STATE';

export interface IUpdate_Query {
  type: typeof UPDATE_QUERY;
  actionData:
    | Pick<ICommonStoreState, 'destination'>
    | Pick<ICommonStoreState, 'checkin'>
    | Pick<ICommonStoreState, 'checkout'>
    | Pick<ICommonStoreState, 'roomString'>
    | Pick<ICommonStoreState, 'partner'>
    | Pick<ICommonStoreState, 'country'>
    | Pick<ICommonStoreState, 'metaPartner'>;
}

export interface IToggleLoadingSegmentSlider {
  type: typeof TOGGLE_LOADING_SEGMENT_SLIDER;
  actionData: ICommonStoreState['segmentSliderApi']['isLoading'];
}

export interface IErrorLoadingSegmentSlider {
  type: typeof ERROR_LOADING_SEGMENT_SLIDER;
  actionData: ICommonStoreState['segmentSliderApi']['error'];
}

export interface IUpdateSegmentSlider {
  type: typeof UPDATE_SEGMENT_SLIDER_DATA;
  actionData: ICommonStoreState['segmentSliderApi']['data'];
}

export interface IResetSegmentSliderData {
  type: typeof RESET_SEGMENT_SLIDER;
}

export interface ISelectedHotel {
  type: typeof UPDATE_SELECTED_PROPERTY;
  payload: ICommonStoreState['selectedHotel'];
}

export interface IResetSelectedHotel {
  type: typeof RESET_SELECTED_PROPERTY;
}

export interface IUpdateAutosuggestOpenedBy {
  type: typeof UPDATE_AUTOSUGGEST_OPENED_BY;
  payload: {
    page: AutosuggestOpenedByPageType;
  };
}

export interface IUpdateCalendarProgressiveSearchFormOpenedBy {
  type: typeof UPDATE_CALENDAR_PROGRESSIVE_SEARCH_FORM_OPENED_BY;
  payload: {
    page: AutosuggestOpenedByPageType;
  };
}

export interface IUpdatePageHeaderSearchWidgetOpenState {
  type: typeof UPDATE_PAGEHEADER_SEARCH_WIDGET_OPEN_STATE;
  payload: {
    isPageHeaderSearchWidgetOpen: ICommonStoreState['isPageHeaderSearchWidgetOpen'];
  };
}

export type CommonActionTypes =
  | IUpdate_Query
  | IToggleLoadingSegmentSlider
  | IUpdateSegmentSlider
  | IResetSegmentSliderData
  | IErrorLoadingSegmentSlider
  | ISelectedHotel
  | IUpdateAutosuggestOpenedBy
  | IUpdatePageHeaderSearchWidgetOpenState
  | IResetSelectedHotel
  | IUpdateCalendarProgressiveSearchFormOpenedBy;
